/** Dashboard lug'ati (uz) */
export default {
  loadError: "Dashboard yuklanmadi.",
  greeting: { morning: "Xayrli tong, {{name}}", afternoon: "Xayrli kun, {{name}}", evening: "Xayrli kech, {{name}}" },
  dateLine: "{{date}} · Dallas {{dallas}} {{abbr}} · Toshkent {{tashkent}}",
  period: "Davr",
  daysValue_one: "{{count}} kun",
  daysValue_other: "{{count}} kun",
  delta: { same: "{{month}} bilan bir xil", vs: "{{arrow}} {{count}} ({{month}} ga nisbatan)" },
  kpi: {
    newDrivers: "Yangi driverlar",
    submitted: "Carrierlarga yuborilgan",
    waitingReply: "{{count}} ta javob kutmoqda",
    hired: "Ishga olingan",
    pendingApproval: "+{{count}} tasdiq kutmoqda",
    approvedByManager: "menejer tasdiqlagan",
    myBonus: "Mening bonusim · {{month}}",
    bonusEstimated: "taxminiy, tasdiqdan keyin yakuniy",
    hires: "Ishga olinganlar",
    hiresPrevIn: "{{month}}: {{count}}",
    pctVsPrev: "{{arrow}} {{pct}}% ({{month}} ga nisbatan)",
    pendingShort: " · {{count}} kutmoqda",
    inPipeline: "Jarayonda",
    activeDrivers: "faol driverlar",
    avgTimeToHire: "O'rtacha ishga olish vaqti",
    vsPrevNone: "{{month}} ga nisbatan: —",
    daysVsPrev: "{{arrow}} {{count}} kun ({{month}} ga nisbatan)",
    daysIn: "{{month}}: {{days}}",
    noHiresYet: "hali ishga olinganlar yo'q",
    retention30: "30 kunlik saqlanish",
    retention30Sub: "30 kundan o'tgan ishga olinganlar",
    costPerHire: "Bir ishga olish narxi",
    costPerHireSub: "xarajatlar + maoshlar + bonuslar",
  },
  myFunnel: "Mening voronkam · {{month}}",
  funnelHint: "% = oldingi bosqichdan o'tish",
  funnel: "Voronka · {{month}}",
  leaderboard: {
    title: "{{scope}} reytingi · {{month}}",
    team: "Jamoa",
    top: "Eng yaxshi recruiterlar · {{month}}",
    full: "To'liq reyting →",
    empty: "Bu oyda hali tasdiqlangan ishga olish yo'q.",
    you: " (siz)",
    hires_one: "{{count}} ta ishga olish",
    hires_other: "{{count}} ta ishga olish",
  },
  lead: { title: "Jamoa ko'rinishi", team: "Jamoa", recruiters: "Recruiterlar · {{month}}", rowHint: "Qator bosilsa → recruiter hisoboti", empty: "Jamoangizda hali recruiterlar yo'q." },
  manager: { title: "Filial ko'rinishi", branch: "Filial", myBranches: "barcha filiallarim", teams: "Jamoalar · {{month}}" },
  owner: { title: "Kompaniya ko'rinishi", allBranches: "barcha filiallar", back: "Barcha filiallarga qaytish", vs: "{{month}} bilan", branches: "Filiallar · {{month}}", rowHint: "Qator bosilsa → shu filial dashboardi", branchesEmpty: "Hali filiallar yo'q." },
  cols: {
    recruiter: "Recruiter", team: "Jamoa", lead: "Rahbar", recruiters: "Recruiterlar", new: "Yangi", submitted: "Yuborilgan", hired: "Ishga olingan",
    retention30: "Saqlanish 30k", avgTime: "O'rt. vaqt", branch: "Filial", budgetUsed: "Byudjet sarfi", costPerHire: "Narx / ishga olish", total: "Jami",
  },
  hiresPerWeek: "Haftalik ishga olishlar",
  hiresPerWeekSub: "tasdiqlangan ishga olishlar, oxirgi 8 hafta",
  hiresTip: "Ishga olingan",
  retention: { days: "{{count}} kun", of: " · {{eligible}} tadan {{retained}}" },
  lossEmpty: "Bu davrda yo'qotilgan driverlar yo'q.",
  approvals: {
    title: "Tasdiq kutayotganlar", waiting: "{{count}} ta qaroringizni kutmoqda",
    hires: "Ishga olishlar", expenses: "Xarajatlar", bonuses: "Bonuslar", transfers: "O'tkazmalar", review: "Ko'rish →", open: "Tasdiqlarni ochish",
  },
  recent: { title: "Yaqinda yangilangan", empty: "Hali driverlar yo'q. Birinchi driverni qo'shing." },
  tasks: { title: "Bugungi vazifalar", all: "Barcha vazifalar →", empty: "Bugunga vazifa yo'q. Zo'r.", markDone: "Bajarildi deb belgilash", doneFailed: "Vazifani bajarilgan deb belgilab bo'lmadi" },
};
